import GameScreen from '../components/GameScreen';
import PromptCollection from '../components/PromptCollection';

function PromptCollectionScreen({
  gameName,
  roomCode,
  onReconnect,
  onQuit,
  promptsPerPlayer,
  submittedPrompts,
  promptText,
  setPromptText,
  onSubmitPrompt,
  promptTimeLeft,
  disableTimers,
}) {
  const timerSeconds = !disableTimers ? promptTimeLeft : 0;

  return (
    <GameScreen
      gameName={gameName}
      roomCode={roomCode}
      onReconnect={onReconnect}
      onQuit={onQuit}
      timerSeconds={timerSeconds}
    >
      <PromptCollection
        promptsPerPlayer={promptsPerPlayer}
        submittedPrompts={submittedPrompts}
        promptText={promptText}
        setPromptText={setPromptText}
        onSubmitPrompt={onSubmitPrompt}
      />
    </GameScreen>
  );
}

export default PromptCollectionScreen;
